import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import REGISTRATION_FIELDS from './constants';
import styles from './RegistrationContainer.scss';

class RegistrationUserNameBlock extends React.Component {
  render() {
    const { translate, renderInput } = this.props;
    return (
      <div className={styles.rowBlock}>
        <div className={styles.columnBlock}>
          <div className={styles.title}>
            {translate('authenticationPage', 'firstName')}
          </div>
          <Field
            name={REGISTRATION_FIELDS.FIRST_NAME}
            type="text"
            component={renderInput}
            placeholder={translate(
              'authenticationPage',
              'firstName'
            )}
          />
        </div>
        <div className={styles.columnBlock}>
          <div className={styles.title}>
            {translate('authenticationPage', 'lastName')}
          </div>
          <Field
            name={REGISTRATION_FIELDS.LAST_NAME}
            type="text"
            component={renderInput}
            placeholder={translate('authenticationPage', 'lastName')}
          />
        </div>
      </div>
    );
  }
}

RegistrationUserNameBlock.propTypes = {
  translate: PropTypes.func,
  renderInput: PropTypes.func
};

export default RegistrationUserNameBlock;
